module.exports = __webpack_public_path__ + "img/arrow.8d8c067a.svg";